export default "/corgi/pageapps/prepurchase/_next/static/media/logo.e4cd74d7.svg";